export var RiskStatusType;
(function (RiskStatusType) {
    RiskStatusType["Active"] = "active";
    RiskStatusType["Emerging"] = "emerging";
    RiskStatusType["Monitored"] = "monitored";
    RiskStatusType["Retired"] = "retired";
})(RiskStatusType || (RiskStatusType = {}));
//# sourceMappingURL=risk-status-type.js.map